import { ParsedRowType } from "../../types";

export const getDisplayIndex = (
  parsed: ParsedRowType[],
  itemId?: string | null,
  isParameterFlag: boolean = false
): string => {
  if (!itemId) return "";

  const item = parsed.find(p => p.id === itemId);
  if (!item) return "";

  let displayIndex: string;

  if (!item.baseId) {
    const rootItems = parsed.filter(p => !p.baseId);
    const rootIndex = rootItems.indexOf(item);
    displayIndex = rootIndex.toString();
  } else {
    const parentItem = parsed.find(p => p.id === item.baseId);
    const parentIndex = parentItem ? getDisplayIndex(parsed, parentItem.id, false) : "0";
    const siblings = parsed.filter(p => p.baseId === item.baseId);
    const siblingIndex = siblings.indexOf(item) + 1;
    displayIndex = `${parentIndex}.${siblingIndex}`;
  }

  if (isParameterFlag && item.parameterType) {
    return `${displayIndex} - ${item.parameterType}`;
  }

  return displayIndex;
};
